/** @jsx jsx */
import { jsx,css } from '@emotion/core'
import React from 'react';
import { IconContext } from "react-icons";
import { MdCropOriginal } from "react-icons/md";
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const icon = css`
  & svg.icon {
    color: #f7c02d;
    width: 40px;
    height: 40px;
    margin-bottom: 5px;
    margin-left: 20px;
    cursor: pointer;
    &:hover {
      color: #ffffff;
    }
    &.icon-trash:hover {
      color: #d44b58;
    }
  }
`;

class Sketch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {

    return (
      <div style={{display: 'inline-block'}} css={icon}>
        <IconContext.Provider value={{ className: 'icon' }}>
          <MdCropOriginal onClick={this.toggle} />
        </IconContext.Provider>
        <Modal isOpen={this.state.modal} toggle={this.toggle} centered={true} className={this.props.className}>
          <ModalHeader toggle={this.toggle}>{this.props.title}</ModalHeader>
          <ModalBody>
            <img className="img-fluid d-block mx-auto mb-4" src={this.props.url} alt="sketch" />
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default Sketch;